import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageType } from 'src/app/Modules/idms/enums/PageType';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { DynamicControlsComponent } from 'src/app/Modules/management/components/modals/organization/dynamic-controls/dynamic-controls.component';
import { ProjectType } from 'src/app/Modules/management/models/instance/project-type.model';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { SaveTaggedItemData } from '../../../plant-manager/models/plant-manager.model';
import { ParamsApiService } from 'src/app/services/params-api.services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ProjectmanagerService } from '../../services/projectmanager.service';
import { ProjectActivityPackDetails } from '../../models/ProjectActivityPackDetails.model';
import { ProjectmanagerSidebarService } from '../../services/project-manager-sidebar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-add-new-projects',
    templateUrl: './add-new-projects.component.html',
    styleUrls: ['./add-new-projects.component.scss'],
    standalone: false,
})
export class AddNewProjectsComponent implements OnInit, OnDestroy {
    isSubscribe: Subject<any> = new Subject<any>();
    @Output() isProjectAdded: EventEmitter<boolean> = new EventEmitter<boolean>();
    private currentProjectTabsubscription: Subscription;
    projecTypeList: ProjectType[] = [];
    selectedProjectType: ProjectType;
    selectedActivitypack: ProjectActivityPackDetails;
    activityPackTypes: any = [];
    jsonObject: any = [];
    selectedproject: any;
    currentProjectTabName: string;
    cardBodymessage: string;
    addNewProject: boolean = false;
    addNewWorkpack: boolean = false;
    index: number = 0;

    constructor(
        private managementApiService: ManagementApiService,
        private user_utlity: UserUtilityService,
        private modalService: NgbModal,
        private idmsSharedService: IdmsSharedService,
        private paramsApiService: ParamsApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastService: CustomToastService,
        private projectmangerService: ProjectmanagerService,
        private projectmanagerSidebarService: ProjectmanagerSidebarService,
        private globalEmitterService: GlobalEmittersService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private cd: ChangeDetectorRef
    ) {}

    async ngOnInit(): Promise<void> {
        let instanceId = localStorage.getItem('currentInstanceId');
        if (this.router.url == '/idms/project-manager') {
            await this.getProjectTypes(instanceId);
        } else if (this.currentProjectTabName === 'Work Packs') {
            await this.getActivitypacksTypes(instanceId);
        }

        await this.handleSubscription(instanceId);
    }

    async handleSubscription(instanceId): Promise<void> {
        this.projectmanagerSidebarService.selectedCardBodyMessage.pipe(takeUntil(this.isSubscribe)).subscribe((res) => {
            this.cardBodymessage = res;
        });

        this.currentProjectTabsubscription = this.projectmangerService.currentProjectTab.pipe(takeUntil(this.isSubscribe)).subscribe(async (resp) => {
            if (resp) {
                this.currentProjectTabName = resp;
                if (this.currentProjectTabName === 'Work Packs') {
                    await this.getActivitypacksTypes(instanceId);
                    this.projectmangerService.currentProjectTab.next(null);
                }
                if (this.router.url == '/idms/project-manager' || resp == 'project') {
                    await this.getProjectTypes(instanceId);
                    this.projectmangerService.currentProjectTab.next(null);
                }
            }
        });

        this.projectmangerService.selectedprojectDetails.pipe(takeUntil(this.isSubscribe)).subscribe((resp) => {
            if (resp) {
                this.selectedproject = resp;
            }
        });

        this.projectmangerService.selectedActivitypack.subscribe((resp) => {
            if (resp) {
                this.selectedActivitypack = resp;
            }
        });

        this.activatedRoute.queryParamMap.pipe(takeUntil(this.isSubscribe)).subscribe((queryParams) => {
            this.index = +queryParams.get('index');
        });

        this.addNewProject = await this.user_utlity.checkUserPermissionDataAndRoute('project-manager', userActions.Create);
        this.addNewWorkpack = await this.user_utlity.checkUserPermissionDataAndRoute('workpack', userActions.Create);
    }

    async getActivitypacksTypes(instanceId) {
        try {
            this.ngxUiLoaderService.start();
            let resp = await this.managementApiService.getActivityPackByInstanceId(instanceId).toPromise();
            if (resp.success) {
                this.activityPackTypes = resp.response.filter((x) => x.isTaggedItemLocal == false && x.isSelected == true);
                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utlity.errorModelPopup(resp.message);
            }
            this.cd.detectChanges();
        } catch (e) {
            this.ngxUiLoaderService.start();
            this.user_utlity.errorModelPopup(e.message);
        }
    }

    async getProjectTypes(instanceId) {
        try {
            this.ngxUiLoaderService.start();
            let res = await this.managementApiService.getProjectTypesByInstanceId(instanceId).toPromise();

            if (res.success) {
                this.projecTypeList = res.response.filter((x) => x.isSelected);
            } else {
                this.user_utlity.errorModelPopup(res.message);
            }
            this.ngxUiLoaderService.stop();
            this.cd.detectChanges();
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    open(ptype) {
        this.currentProjectTabName == 'Work Packs' ? (this.selectedActivitypack = ptype) : (this.selectedProjectType = ptype);

        let jsonString = ptype.schemaVersions[ptype.schemaVersions.length - 1].schema;
        let dialogRef = this.modalService.open(DynamicControlsComponent, {
            size: 'xl',
        });

        dialogRef.componentInstance.jsonString = jsonString;
        dialogRef.componentInstance.mode = 'pop-up';
        dialogRef.componentInstance.permission = true;
        this.currentProjectTabName == 'Work Packs'
            ? (dialogRef.componentInstance.PageType = PageType.ActivityPackAdd)
            : (dialogRef.componentInstance.PageType = PageType.ProjectManagerCreate);
        this.currentProjectTabName == 'Work Packs'
            ? (dialogRef.componentInstance.pagetitle = 'Add ActivityPack')
            : (dialogRef.componentInstance.pagetitle = 'Add Project');
        dialogRef.componentInstance.preCloseSaveHandler = async (result: SaveTaggedItemData) => {
            if (!result) {
                return false;
            }

            if (result.images.length) {
                let images = result.images;
                let url: string = '';
                let res = await this.idmsSharedService.getBlobImageUrl(images).toPromise();

                if (res.success) {
                    url = url == '' ? url + res.response.path : url + ',' + res.response.path;
                    result.ImageUrl = url;
                } else {
                    this.user_utlity.errorModelPopup(res.message);
                    return false;
                }
            }

            let data = this.idmsSharedService.extractGroupData(result.schemsForm.value, result);
            data.Datas = data.Datas.replace(/}{/g, ',');

            let payload: any = {
                namePrimary: data.NamePrimary,
                nameSecondary: data.NameSecondary,
                logo: data.ImageKey,
                dataContent: data.Datas,
            };
            this.currentProjectTabName == 'Work Packs'
                ? (payload.schemaVersionId = this.selectedActivitypack.schemaVersions[this.selectedActivitypack.schemaVersions.length - 1].schemaVersionId)
                : (payload.schemaVersionId = this.selectedProjectType.schemaVersions[this.selectedProjectType.schemaVersions.length - 1].schemaVersionId);

            return this.currentProjectTabName == 'Work Packs'
                ? await this.addNewActivitypackInProjectApiCall([payload])
                : await this.addNewProjectApiCall([payload]);
        };

        dialogRef.result
            .then(async (result: SaveTaggedItemData) => {
                if (result) {
                    this.cd.detectChanges();
                } else {
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    async addNewProjectApiCall(payload): Promise<boolean> {
        try {
            let resp = await this.paramsApiService.addProject(payload).toPromise();
            if (resp.success) {
                if (resp?.approvalAction && resp?.approvalAction > 0 && resp?.approvalAction <= 2) {
                    this.customToastService.successToast(resp.message, 'Success');
                } else {
                    this.customToastService.successToast('New project added successfully', 'Success');
                }
                if (resp.response) {
                    this.router.navigate([`/idms/project-manager/${resp.response[0].projectId}`]);
                    this.projectmangerService.selectedProjectData = resp.response[0];
                }
                this.projectmangerService.isProjectRefresh.next(true);
                this.ngxUiLoaderService.stop();
                return true;
            } else {
                this.customToastService.errorToast(resp.message, 'Error');
                this.ngxUiLoaderService.stop();
                return false;
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Failed to update project details. Please try again or contact administrator.', 'Error');
            return false;
        }
    }

    async addNewActivitypackInProjectApiCall(payload): Promise<boolean> {
        try {
            let resp = await this.paramsApiService.addActivityPackWithInProject(this.selectedproject.projectId, payload).toPromise();
            if (resp.success) {
                this.globalEmitterService.isrefreshProjectDetails.next(true);
                if (resp.response) {
                    this.router.navigate([`/idms/project-manager/${this.selectedproject.projectId}/workpack/${resp.response[0].activityPackId}`], {
                        queryParams: { index: this.index },
                    });
                }
                if (resp?.approvalAction && resp?.approvalAction > 0 && resp?.approvalAction <= 2) {
                    this.customToastService.successToast(resp.message, 'Success');
                } else {
                    this.customToastService.successToast('Work pack added successfully.', 'Success');
                }
                this.ngxUiLoaderService.stop();
                return true;
            } else {
                this.customToastService.errorToast(resp.message, 'Error');
                this.ngxUiLoaderService.stop();
                return false;
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Failed to add new update Work pack. Please try again or contact administrator.', 'Error');
            return false;
        }
    }

    ngOnDestroy(): void {
        this.isSubscribe.unsubscribe();
        if (this.currentProjectTabsubscription) {
            this.currentProjectTabsubscription.unsubscribe();
        }
    }
}
